import MailOutline from "@mui/icons-material/MailOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styled from "styled-components";
import { mobile } from "../responsive";
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";

const Container = styled.div`
  display: flex;
  margin-top: 10px;
  border-top: solid 1px lightgrey;
  background-color: #F7F7F7;
  );

  ${mobile({ flexDirection: "column" })}
`;

const ContainerLower = styled.div`
  display: flex;
  background-color: #FFF;
  padding: 1em 1em;
  text-align: center;
  );

`;
const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;
const Logo = styled.h1`
  font-family: bebas neue;
  letter-spacing: 0.05em;
`;
const Desc = styled.p`
  margin: 20px 0px;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  padding: 20px;
  flex-direction: column;
`;
const Center = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  ${mobile({ display: "none" })}
`;

const Title = styled.p`
  font-weight: bold;
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;
const ListItem = styled.li`
  width: 50%;
  margin-bottom: 10px;
`;

const ContactItem = styled.div`
  margin: 0.5em 0;
  display: flex;
  flex: 1;
  align-items: center;
`;

const Footer = () => {
  return (
    <>
      <Container>
        <Left>
          <Logo>
            Rentoodle
            <sup style={{ fontSize: "12px" }}> ®</sup>
          </Logo>
          <Desc>Rent Ooodles of things.</Desc>
        </Left>
        <Center>
          <List>
            <ListItem>
              <Title>Top Categories</Title>
            </ListItem>
            <ListItem>
              <Link
                to="/products/book-genres"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent books
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/toys-and-games"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent toys
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/diy-and-tools"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent tools
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/womens-fashion"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent womenswear
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/sports-and-outdoors"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent sports equipment
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/home-and-kitchen"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent home & kitchen
              </Link>
            </ListItem>
            <ListItem>
              <Link
                to="/products/electronics-and-photo"
                style={{ textDecorationLine: "none", color: "#333" }}
              >
                Rent cameras
              </Link>
            </ListItem>
          </List>
        </Center>
        <Right>
          <Title>Customer Services</Title>
          {/* <ContactItem>
            <HelpCenter style={{ marginRight: "1em" }} />
            FAQs
          </ContactItem>
          <ContactItem>
            <WhatsApp style={{ marginRight: "1em" }} />
            Connect with us on WhatsApp
          </ContactItem> */}
          <Link
            to="/faqs"
            style={{
              textDecoration: "none",
              color: "#3A3A3A",
            }}
          >
            <ContactItem>
              <HelpOutlineIcon style={{ marginRight: "1em" }} />
              How Rentoodle works
            </ContactItem>
          </Link>
          <Link
            to="/support-ticket"
            style={{
              textDecoration: "none",
              color: "#3A3A3A",
            }}
          >
            <ContactItem>
              <MailOutline style={{ marginRight: "1em" }} />
              Contact us
            </ContactItem>
          </Link>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              marginLeft: "0.3em",
            }}
          >
            <Link
              to={{ pathname: "https://twitter.com/rentoodle" }}
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#3A3A3A",
                padding: "0 1em",
              }}
            >
              <ContactItem>
                <img
                  src="https://www.rentoodle.com/img/x-logo.svg"
                  width="18px"
                  height="18px"
                  alt="X formerly Twitter logo"
                  style={{ marginRight: "0.3em" }}
                />
              </ContactItem>
            </Link>
            <Link
              to={{ pathname: "https://instagram.com/rentoodle" }}
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#3A3A3A",
                padding: "0 1em",
              }}
            >
              <ContactItem>
                <InstagramIcon style={{ marginRight: "0.3em" }} />
              </ContactItem>
            </Link>
            <Link
              to={{ pathname: "https://tiktok.com/@rentoodle" }}
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#3A3A3A",
                padding: "0 1em",
              }}
            >
              <ContactItem>
                <img
                  src="https://www.rentoodle.com/img/logo-tiktok.svg"
                  width="18px"
                  height="18px"
                  alt="TikTok logo"
                  style={{ marginRight: "0.3em" }}
                />
              </ContactItem>
            </Link>
          </div>
        </Right>
      </Container>
      <ContainerLower>
        <p style={{ fontSize: "12px", color: "#333" }}>
          © Rentoodle. All Rights Reserved.{" "}
          <Link
            to="/terms"
            style={{ textDecoration: "underline", color: "#4339fa" }}
          >
            Terms & Conditions
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy"
            style={{ textDecoration: "underline", color: "#4339fa" }}
          >
            Privacy
          </Link>
          . Rentoodle is a trademark. Insurance is underwritten by Hiscox.
          Rentoodle marketplace is operated by Rentoodle Limited, registered in
          England whose registered office is Harwood House, Harwood Road,
          Fulham, London, SW6 4QP.
        </p>
      </ContainerLower>
    </>
  );
};

export default Footer;
